import { render, staticRenderFns } from "./VEmployerCompanyDocumentsBrowse.vue?vue&type=template&id=9bfd5a5e&lang=pug"
import script from "./VEmployerCompanyDocumentsBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompanyDocumentsBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports